var Handlebars = require("../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<i>"
    + container.escapeExpression(__default(require("../../../../../src/helpers/t.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"No layers available",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":1,"column":3},"end":{"line":1,"column":32}}}))
    + "</i>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /~/eoxc/src/search/views/NoLayersAvailable.hbs
// module id = 2051
// module chunks = 0